export interface QuantityInputOptions {
  min?: number
}

export class QuantityInputState {
  private _displayValue: string
  private _shouldAutoSelect: boolean
  private _min: number
  
  constructor(initialValue: number, options: QuantityInputOptions = {}) {
    this._min = options.min ?? 1
    this._displayValue = initialValue.toString()
    this._shouldAutoSelect = true
  }
  
  get displayValue(): string {
    return this._displayValue
  }
  
  get shouldAutoSelect(): boolean {
    return this._shouldAutoSelect
  }
  
  get isValid(): boolean {
    const numericValue = parseInt(this._displayValue, 10)
    return !isNaN(numericValue) && numericValue >= this._min
  }
  
  handleChange(value: string, onChange: (value: number) => void): void {
    // Disable auto-select after first keystroke
    if (this._shouldAutoSelect) {
      this._shouldAutoSelect = false
    }
    
    // Always update display value immediately
    this._displayValue = value
    
    // Only call onChange for valid positive numbers
    const numericValue = parseInt(value, 10)
    if (!isNaN(numericValue) && numericValue > 0) {
      onChange(numericValue)
    }
  }
  
  handleFocus(): boolean {
    // Returns whether auto-select should happen
    return this._shouldAutoSelect
  }
  
  handleBlur(inputValue: string, onChange: (value: number) => void): void {
    const numericValue = parseInt(inputValue, 10)
    
    // Reset invalid values to minimum
    if (inputValue === '' || isNaN(numericValue) || numericValue < this._min) {
      this._displayValue = this._min.toString()
      onChange(this._min)
    }
    
    // Disable auto-select after blur
    this._shouldAutoSelect = false
  }
  
  reset(newValue: number): void {
    this._displayValue = newValue.toString()
    this._shouldAutoSelect = true
  }
} 